<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da želite da uklonite korisnika
        {{ member.user_full_name }}?
      </p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="removeMember"
        :disabled="loading"
      >
        <span v-if="!loading">Pošalji</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['member']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['getActiveMembersByCommunity']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),

    removeMember() {
      if (this.loading) {
        return;
      }

      this.loadingStarted();
      let removeRequest = {
        community_id: this.member.community_id,
        member_id: this.member.id
      };
      this.loadingStarted();
      axios
        .post('/member/remove', removeRequest)
        .then(() => {
          this.getActiveMembersByCommunity(this.$route.params.id);
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped></style>
